import React, { useEffect, useState, useCallback, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiExport, BiListOl, BiRefresh, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import * as moment from 'moment';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';
import Iframe from 'react-iframe';
import { EcryptService } from '../../../services/EcryptService';

const Laboratorium = () => {
    const [listDpjp, setlistDpjp] = useState([]);
    const [selectedDpjp, setselectedDpjp] = useState();
    const [selectedData, setselectedData] = useState();
    const [periodeAwal, setperiodeAwal] = useState();
    const [periodeAkhir, setperiodeAkhir] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [hasilLab, setHasilLab] = useState(null);
    const [listLaboratorium, setListLaboratorium] = useState([]);
    const timeoutRef = useRef(null);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const [showFile, setshowFile] = useState();
    const handleCloseDeskripsi = () => { setshowDeskripsi(false); setHasilLab(null); setselectedData(null) };
    const handleCloseFile = () => setshowFile(false);
    const [urlDoc, seturlDoc] = useState(null)

    const handleChangeDpjp = (row) => {
        setselectedDpjp(row)
    }
    const handlePeriodeAwal = () => {
        setperiodeAwal($('#laboratoriumawal1').val());
    }
    const handlePeriodeAkhir = () => {
        setperiodeAkhir($('#laboratoriumawal2').val());
    }

    const loadInit = async () => {
        setIsLoading(true)
        let tglAwal = moment(periodeAwal).format('YYYY-MM-DD HH:mm:ss');
        let tglAkhir = moment(periodeAkhir).format('YYYY-MM-DD HH:mm:ss');
        let param = '';
        // param += `NoCm=${$('#nocm').text()}`
        // param += periodeAwal ? `&tglAwal=${tglAwal}` : '';
        // param += periodeAkhir ? `&tglAkhir=${tglAkhir}` : '';
        // param += selectedDpjp ? `&iddpjp=${selectedDpjp.id}` : '';
        param += `noregistrasi=${$('#noRegistrasi').text()}`;

        try {
            const response = await VedikaService.getOrderLabNew(param);
            setListLaboratorium(response.data.daftar)
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        } finally {
            setIsLoading(false)
        }
    }
    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        setIsLoading(true)
        setselectedData(row)
        if (row.objectruanganfk == 39) {
            VedikaService.getHasilLabPA(row.noorder)
                .then((e) => {
                    setHasilLab(e.data.data)
                    return e;
                })
                .then((e) => {
                    setTimeout(() => {
                        $('#hasil').html(formattedString(e.data.data.details[0].hasil))
                    }, 500);
                })
                .finally(() => {
                    setIsLoading(false)
                })
        } else {
            VedikaService.getHasilLab(row.noorder)
                .then((e) => {
                    setHasilLab(e.data.data)
                    loadDtDeskripsi(e.data.data)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }


    }
    // const handleShowFile = (row) => {
    //     setshowFile(true);
    //     if (row.objectruanganfk == 39) {
    //         const noRm = $('#nocm').text()
    //         const folderName = moment(row.tglorder, "DD-MM-YYYY HH:mm:ss").format('YYYYMMDD');
    //         const stringEcrypt = EcryptService.getEncrypt(row.noorder);
    //         const encodedData = encodeURIComponent(stringEcrypt);
    //         setTimeout(() => {
    //             seturlDoc(`http://localhost:4000/viewer-file?name=${encodedData}&from=vedika&download=true&norm=${noRm}&pathFolder=${folderName}`);
    //         }, 800);
    //     } else {    
    //         let url = 'https://vedika.rsabhk.co.id/service-reporting/lap-lab/' + row.noorder;
    //         const stringEcrypt = EcryptService.getEncrypt(url);
    //         const encodedData = encodeURIComponent(stringEcrypt);
    //         setTimeout(() => {
    //             seturlDoc(`http://localhost:4000/viewer-url?document=${encodedData}&from=vedika&download=false`);
    //         }, 800);
    //     }
    // }

    const handleShowFile = useCallback((row) => {
        // Bersihkan timeout sebelumnya jika ada
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        // Set timeout untuk mengatur URL dokumen
        timeoutRef.current = setTimeout(() => {
            let url = ''
            if (row.objectruanganfk == 39) {
                const noRm = $('#nocm').text()
                const folderName = moment(row.tglorder, "DD-MM-YYYY HH:mm:ss").format('YYYYMMDD');
                const stringEcrypt = EcryptService.getEncrypt(row.noorder);
                const encodedData = encodeURIComponent(stringEcrypt);
                url = `https://viewer.rsabhk.co.id/viewer-file?name=${encodedData}&from=vedika&download=true&norm=${noRm}&pathFolder=${folderName}`
                seturlDoc(url);
                setshowFile(true);
            } else {
                let url = 'https://vedika.rsabhk.co.id/service-reporting/lap-lab/' + row.noorder;
                const stringEcrypt = EcryptService.getEncrypt(url);
                const encodedData = encodeURIComponent(stringEcrypt);
                url = `https://viewer.rsabhk.co.id/viewer-url?document=${encodedData}&from=vedika&download=false`
                seturlDoc(url);
                setshowFile(true);
            }

        }, 100); // Ganti dengan waktu yang sesuai

    }, []);

    // const exportPdf = (row) => {
    //     window.open('https://vedika.rsabhk.co.id/service-reporting/lap-lab/' + row.noorder);
    // }

    const loadDtList = () => {
        $('#dtLaboratorium').DataTable({
            data: listLaboratorium,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    width: '10%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Detail' id="tooltip3" onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='PDF' id="tooltip2" onClick={() => handleShowFile(rowData)}><BiExport /></Button></ButtonGroup></div>),
                },
                {
                    targets: [1],
                    width: '20%',
                    data: 'noorder',
                },
                {
                    targets: [2],
                    width: '15%',
                    data: 'tglorder',
                },
                {
                    targets: [3],
                    width: '25%',
                    data: null,
                    // data: 'dokterperiksa',
                    createdCell:(td, cellData, rowData, row, col) => createRoot(td).render(<span>{ $('#dpjp').val()}</span>)
                },
                {
                    targets: [3],
                    width: '30%',
                    data: 'namaruanganasal',
                },
            ]
        })
    }

    const loadDtDeskripsi = async (res) => {
        setTimeout(() => {
            $('#dtDetailHasilLab').DataTable({
                data: res.details,
                ordering: false,
                pageLength: 10,
                scrollCollapse: true,
                scrollY: '50vh',
                destroy: true,
                searching: false,
                bFilter: false,
                bLengthChange: false,
                paging: false,
                columns: [
                    {
                        targets: [0],
                        data: 'nama_grup',
                        width: '15%',
                        createdCell: (td, cellData, rowData, row, col) => { ['ST'].includes(rowData.data_typ) ? createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.nama_grup}</span>) : ['FT'].includes(rowData.data_typ) ? createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.nama_grup}</span>) : createRoot(td).render(rowData.nama_grup) },
                    },
                    {
                        targets: [1],
                        data: 'test_nm',
                        width: '25%',
                        createdCell: (td, cellData, rowData, row, col) => {
                            let result = '';
                            if (['ST'].includes(rowData.data_typ)) {
                                if (['REPORT'].includes(rowData.test_nm)) {
                                    createRoot(td).render(rowData.hasil_ft)
                                } else {
                                    createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.test_nm}</span>)
                                }
                            }

                            if (['FT'].includes(rowData.data_typ)) {
                                if (['REPORT'].includes(rowData.test_nm)) {
                                    createRoot(td).render(rowData.hasil_ft)
                                } else {
                                    createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.test_nm}</span>)
                                }
                            }
                        },
                    },
                    {
                        targets: [2],
                        data: null,
                        createdCell: (td, cellData, rowData, row, col) => { ['N', ''].includes(rowData.flag) ? createRoot(td).render('') : createRoot(td).render(<span style={{ fontWeight: 'bold' }}>*{rowData.flag}</span>) },
                        width: '2%'
                    },
                    {
                        targets: [3],
                        data: null,
                        createdCell: (td, cellData, rowData, row, col) => { ['N', ''].includes(rowData.flag) ? createRoot(td).render(rowData.nilai_rujukan) : createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.nilai_rujukan}</span>) },
                    },
                    {
                        targets: [4],
                        data: null,
                        createdCell: (td, cellData, rowData, row, col) => { createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.satuan}</span>) },
                    },
                    {
                        targets: [5],
                        data: null,
                        createdCell: (td, cellData, rowData, row, col) => { ['N', ''].includes(rowData.flag) ? createRoot(td).render(rowData.hasil) : createRoot(td).render(<span style={{ fontWeight: 'bold' }}>{rowData.hasil}</span>) },
                    },
                    {
                        targets: [6],
                        data: null,
                        createdCell: (td, cellData, rowData, row, col) => { ![''].includes(rowData.test_comment) ? createRoot(td).render(rowData.test_comment) : createRoot(td).render('') },
                    },
                ],
                order: [
                    [0, 'asc'],
                ],
                rowGroup: {
                    dataSrc: [0]
                },
            })
        }, 2000);
    }

    const formattedString = (rawText) => {
        let formattedText = rawText
            .replace(/\n\t:\n\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;")
            .replace(/\n\t: \n\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;");

        // Langkah 2: Ganti \n\t yang diikuti huruf/angka menjadi baris baru
        // Regex ini mencari \n\t diikuti dengan huruf atau angka
        formattedText = formattedText.replace(/\n\t(?=[a-zA-Z0-9])/g, "<br>");

        // Langkah 3: Bersihkan whitespace berlebih
        formattedText = formattedText.replace(/\s+/g, " ").trim();

        // Langkah 4: Perbaiki formatting untuk readability yang lebih baik
        formattedText = formattedText
            .replace(/ <br>/g, "<br>")  // Hapus spasi sebelum <br>
            .replace(/<br> /g, "<br>");  // Hapus spasi setelah <br>

        return formattedText;
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {
        loadDtList();
    }, [listLaboratorium]);

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 2000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Laboratorium</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/laboratorium/${$('#norec').val()}`} style={{ textDecoration: 'none', color: 'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row className='mb-3 pt-1'>
                {/* <Form.Group as={Col} controlId="laboratoriumawal1">
                    <Form.Label>Periode Awal</Form.Label>
                    <Form.Control size="sm" type="datetime-local" onChange={handlePeriodeAwal} ></Form.Control>
                </Form.Group>
                <Form.Group as={Col} controlId="laboratoriumawal2">
                    <Form.Label>Periode Akhir</Form.Label>
                    <Form.Control size="sm" type="datetime-local" onChange={handlePeriodeAkhir}></Form.Control>
                </Form.Group> */}
                {/* <Form.Group as={Col} controlId="ruangan2">
                    <Form.Label>Dpjp</Form.Label>
                    <Select
                        cacheOptions
                        styles={customStyles}
                        value={selectedDpjp}
                        getOptionLabel={e => e.namalengkap}
                        getOptionValue={e => e.id}
                        options={listDpjp}
                        onChange={handleChangeDpjp}
                    />
                </Form.Group> */}
                {/* <Form.Group as={Col} id="search">
                    <div className="d-grid gap-2">
                        <Button className='mtc-2' variant="success" size="sm" onClick={search}><BiSearchAlt />Cari</Button>
                    </div>
                </Form.Group> */}
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtLaboratorium' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>No Order</th>
                                <th>Tgl Order</th>
                                <th>DPJP</th>
                                <th>Ruangan</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        hasilLab ? (
                            <>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col md={4}>
                                                <p className='f7'><strong>Nomor Order</strong><br />{hasilLab.noorder}</p>
                                            </Col>
                                            <Col md={4}>
                                                <p className='f7'><strong>Tanggal Order</strong><br />{hasilLab.tanggal_order}</p>
                                            </Col>
                                            <Col md={4}>
                                                <p className='f7'><strong>Tanggal Hasil</strong><br />{hasilLab.tanggal_hasil}</p>
                                            </Col>
                                            <Col md={4}>
                                                <p className='f7'><strong>Dokter Pemeriksa</strong><br />{hasilLab.dokter_pemeriksa}</p>
                                            </Col>
                                            <Col md={4}>
                                                <p className='f7'><strong>Ruangan Asal</strong><br />{hasilLab.ruangan_asal}</p>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <Card className='mt-2'>
                                    <Card.Header>
                                        <h5>Detail</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col md={12} >
                                                {
                                                    selectedData.objectruanganfk == 39 ? <Row>
                                                        <Col md={4}>
                                                            <p className='f7'><strong>No. PA</strong><br />{hasilLab.details[0].nopa}</p>
                                                        </Col>
                                                        <Col md={4}>
                                                            <p className='f7'><strong>Tanggal</strong><br />{hasilLab.details[0].received_on}</p>
                                                        </Col>
                                                        <Col md={4}>
                                                            <p className='f7'><strong>Test DC</strong><br />{hasilLab.details[0].test_cd}</p>
                                                        </Col>
                                                        <Col md={4}>
                                                            <p className='f7'><strong>Terminologi Code</strong><br />{hasilLab.details[0].terminologi_code}</p>
                                                        </Col>
                                                        <Col md={8}>
                                                            <p className='f7'><strong>Terminologi Deskripsi</strong><br />{hasilLab.details[0].terminologi_desc}</p>
                                                        </Col>
                                                        <Col md={12}>
                                                            <p className='f7'><strong>Hasil</strong></p>
                                                            <p style={{ fontSize: 'smaller' }} id="hasil"></p>
                                                        </Col>
                                                    </Row>
                                                        : <Table responsive="sm" size="sm" id='dtDetailHasilLab' hover style={{ fontSize: 'smaller' }}>
                                                            <thead>
                                                                <tr>
                                                                    <th>Nama Tindakan</th>
                                                                    <th>Parameter</th>
                                                                    <th></th>
                                                                    <th>Nilai Rujukan</th>
                                                                    <th>Satuan</th>
                                                                    <th>Hasil</th>
                                                                    <th>Keterangan</th>
                                                                </tr>
                                                            </thead>
                                                        </Table>
                                                }

                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </>
                        ) : null
                    }
                </Modal.Body>
            </Modal>
            <Modal
                show={showFile}
                onHide={handleCloseFile}
                backdrop="static"
                size='xl'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Document view</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            {/* <iframe id='frameFile' width="750" height="600"></iframe> */}
                            <Iframe
                                url={urlDoc}
                                width="1100px"
                                height="700px"

                                display="block"
                                position="relative"
                            />
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Laboratorium;